
import { MenuItem, FormControl, Select, useTheme, useMediaQuery } from '@mui/material';
import { FR, GB, TN, IT, ES, TR, DE } from 'country-flag-icons/react/3x2';
import { useTranslation } from 'react-i18next';

export const LanguageSelectorComponent = ({ language, handleLanguageChange, blackStyle,fullWidth=false }) => {
  const { t } = useTranslation()
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));


  return (
    <FormControl variant="outlined" fullWidth={fullWidth}>
      <Select
        value={language}
        onChange={handleLanguageChange}

        sx={{
          border: '1px solid',
          borderColor: (isSmallScreen || blackStyle) ? '#000' : '#fff',

          '& .MuiSelect-select': {
            color: (isSmallScreen || blackStyle) ? '#000' : '#fff',
            fontWeight: "bold"
          }
        }}
      >
        <MenuItem value="fr">
          <FR width="20" alt="French" style={{ marginRight: '8px' }} />
          {t('langue1.1')}
        </MenuItem>
        <MenuItem value="en">
          <GB width="20" alt="English" style={{ marginRight: '8px' }} />
          {t('langue2.1')}
        </MenuItem>
        <MenuItem value="ar">
          <TN width="20" alt="Arabic" style={{ marginRight: '8px' }} />
          {t('langue3.1')}
        </MenuItem>
        <MenuItem value="it">
          <IT width="20" alt="Italian" style={{ marginRight: '8px' }} />
          {t('langue4.1')}
        </MenuItem>
        <MenuItem value="es">
          <ES width="20" alt="Spanish" style={{ marginRight: '8px' }} />
          {t('langue5.1')}
        </MenuItem>
        <MenuItem value="tr">
          <TR width="20" alt="Turkish" style={{ marginRight: '8px' }} />
          {t('langue6.1')}
        </MenuItem>
        <MenuItem value="de">
          <DE width="20" alt="German" style={{ marginRight: '8px' }} />
          {t('langue7.1')}
        </MenuItem>
      </Select>
    </FormControl>
  );
};